import { render, staticRenderFns } from "./adjustmentBetweenCustomers.vue?vue&type=template&id=e92775d0&scoped=true"
import script from "./adjustmentBetweenCustomers.ts?vue&type=script&lang=js&external"
export * from "./adjustmentBetweenCustomers.ts?vue&type=script&lang=js&external"
import style0 from "./adjustmentBetweenCustomers.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./adjustmentBetweenCustomers.vue?vue&type=style&index=1&id=e92775d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92775d0",
  null
  
)

export default component.exports